import type { AxiosInstance } from "axios"
import SpireIntegrationsClient from "./Integrations.Spire.Client"
import GenesisCareIntegrationsClient from "../Integrations.GenesisCare.Client"

export class IntegrationsClient {
	constructor(private axiosClient: AxiosInstance) {
		this.genesisCare = new GenesisCareIntegrationsClient(axiosClient)
		this.spire = new SpireIntegrationsClient(axiosClient)
	}

	public genesisCare: GenesisCareIntegrationsClient
	public spire: SpireIntegrationsClient

	public importUnpackTransformAndMerge = (file: File) => this.axiosClient.postForm("/api/admin/import/unpacktransformmerge", {
		files: [file]
	});
}
